<template>
    <div class="flex" style="width:100%;">
        <div class="flex secondgroup">
            <div class="flex flex-column reportperiod dropdown">
                <label for="periodOption" style="display: block;">Period Option</label>
                <Dropdown id="periodOption" v-model="selectedPeriod" :options="periods" optionLabel="name" placeholder="Select Period" @change="setPeriodDates" style="min-width:10rem;" />
            </div>

            <div class="flex flex-column start dropdown">
                <label for="startDate" style="display: block;">Period Start</label>
                <Calendar id="startDate" v-model="startDate" @update:modelValue="updateStartDate" />
            </div>
        
            <div class="flex flex-column end dropdown">
                <label for="endDate" style="display: block;">Period End</label>
                <Calendar id="endDate" v-model="endDate" @update:modelValue="updateEndDate" />
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { setServicePackageSales } from '@/composables/useInputParameters';
import moment from 'moment';

onMounted(async () => {
    selectedPeriod.value = periods.value[2];
    setServicePackageSales(startDate.value, endDate.value);
});

const selectedPeriod = ref();
const periods = ref([
    { name: 'Today', code: 'today' },
    { name: 'This Week', code: 'tw' },
    { name: 'This Month', code: 'tm' },
    { name: 'This Quarter', code: 'tq' },
    { name: 'This Year', code: 'ty' },
    { name: 'Yesterday', code: 'yesterday' },
    { name: 'Last Week', code: 'lw' },
    { name: 'Last Month', code: 'lm' },
    { name: 'Last Quarter', code: 'lq' },
    { name: 'Last Year', code: 'ly' }
]);

const startDate = ref(moment().startOf('month').format('MM/DD/YYYY'));
const endDate = ref(moment().endOf('month').format('MM/DD/YYYY'));

const updateStartDate = () => {
    endDate.value = '';
}

const updateEndDate = async () => {
    startDate.value = moment(startDate.value).format('MM/DD/YYYY');
    endDate.value = moment(endDate.value).format('MM/DD/YYYY');
    setServicePackageSales(startDate.value, endDate.value);
}

const setPeriodDates = () => {
    const today = moment();
    let start, end;

    switch (selectedPeriod.value.code) {
      case 'today':
          start = end = today;
          break;
      case 'yesterday':
          start = end = today.subtract(1, 'day');
          break;
      case 'tw':
          start = today.clone().startOf('week');
          end = today.clone().endOf('week');
          break;
      case 'tm':
          start = today.clone().startOf('month');
          end = today.clone().endOf('month');
          break;
      case 'tq':
          start = today.clone().startOf('quarter');
          end = today.clone().endOf('quarter');
          break;
      case 'ty':
          start = today.clone().startOf('year');
          end = today.clone().endOf('year');
          break;
      case 'lw':
          start = today.clone().subtract(1, 'week').startOf('week');
          end = today.clone().subtract(1, 'week').endOf('week');
          break;
      case 'lm':
          start = today.clone().subtract(1, 'month').startOf('month');
          end = today.clone().subtract(1, 'month').endOf('month');
          break;
      case 'lq':
          start = today.clone().subtract(1, 'quarter').startOf('quarter');
          end = today.clone().subtract(1, 'quarter').endOf('quarter');
          break;
      case 'ly':
          start = today.clone().subtract(1, 'year').startOf('year');
          end = today.clone().subtract(1, 'year').endOf('year');
          break;
    }

    const startCalendarElement = document.getElementById('startDate')?.querySelector('input');
    const endCalendarElement = document.getElementById('endDate')?.querySelector('input');
    const startDateValue = moment(start.toDate()).format('MM/DD/YYYY');
    const endDateValue = moment(end.toDate()).format('MM/DD/YYYY');
    startCalendarElement.value = `${startDateValue}`;
    endCalendarElement.value = `${endDateValue}`;
    startDate.value = startDateValue;
    endDate.value = endDateValue;

    setServicePackageSales(startDate.value, endDate.value);
}
</script>